import { Component, OnInit } from "@angular/core";
import { Globals } from "../../_models/globals";
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";
import { ApiIntegration } from "../../_services/api.integration";
//import {LocalStorageService,SessionStorageService,} from "angular-web-storage";
import { User } from "../../_models/user";
import { environment } from "../../../environments/environment";
import { Contacts } from "../../_models/contacts";
import { AlertService } from "../../_services/alert.service";
import { PayService } from "../../_services/pay.service";

@Component({
  selector: "app-payment-processing",
  templateUrl: "./payment-processing.component.html",
  styleUrls: ["./payment-processing.component.css"],
})
export class PaymentProcessingComponent implements OnInit {
  payMent: any = {};
  imageUrl: string;
  productImage: string = "/assets/images/default-product.png";
  bankName: any = [];
  accountNumber: any = [];
  branch: any = [];
  ifsc: any = [];
  comments: string;
  refNum: string;
  externalRefNum: string;
  amount: string;
  receiptNum: string;
  chequeNum: string;
  paymentType: string;
  selectedPaymentMode: any = {};
  //paymentMode: string;
  paymentMode: any = [];
  statusText1: string;
  statusText2: string;
  statusText3: string;
  statusText4: string;
  statusText5: string;
  errorMessage: string;
  displayImage: string;
  uploadImage: string;
  totalAmount: any;
  calculatedAmount: any;
  payMentId: any;
  storeId: any;
  url = "http://localhost:4200/access/rzrPmtAuth";
  constructor(
    private payService: PayService,
    private alertService: AlertService,
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private api: ApiIntegration,
    private g: Globals,
    public user: User
  ) {
    this.g.page = "Payment method";
    this.paymentType = "MANUAL";
    this.api.getInvoicesById(this.route.snapshot.params["id"]).subscribe(
        (data: any) => {
          this.payMent = data;
          this.payMentId = data.id;
          this.totalAmount = this.payMent.totalAmount;
          this.calculatedAmount = this.totalAmount * 100;
        },
        (err) => {
          this.alertService.error("Error", err);
        }
      );

    this.api
      .getValues("1", "PAYMENT_TYPE", "PAYMENT_TYPE", "PAYMENT_TYPE")
      .subscribe(
        (data: any) => {
          this.paymentMode = data.tripleSetConfigDTOS;
        },
        (err) => {
          this.alertService.error("Error", err);
        }
      );
    this.api.getValues("1", "BANK_DETAILS", "BANK_NAME", "BANK_NAME").subscribe(
      (data: any) => {
        this.bankName = data.tripleSetConfigDTOS;
      },
      (err) => {
        console.log(err);
      }
    );
    this.api
      .getValues("1", "BANK_DETAILS", "ACCOUNT_NUM", "ACCOUNT_NUM")
      .subscribe(
        (data: any) => {
          this.accountNumber = data.tripleSetConfigDTOS;
        },
        (err) => {
          console.log(err);
        }
      );
    this.api.getValues("1", "BANK_DETAILS", "BRANCH", "BRANCH").subscribe(
      (data: any) => {
        this.branch = data.tripleSetConfigDTOS;
      },
      (err) => {
        console.log(err);
      }
    );
    this.api.getValues("1", "BANK_DETAILS", "IFSC_CODE", "IFSC_CODE").subscribe(
      (data: any) => {
        this.ifsc = data.tripleSetConfigDTOS;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  ngOnInit() { }

  updateSuccessfulPayment(response) {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append("Content-Type", "application/json");
    header1 = header1.append("Accept", "application/json");
    header1 = header1.append(
      "Authorization",
      "Bearer " + localStorage.getItem("jwt")
    );
    this.http
      .post(
        environment.apiUrl + "api/updatePaymentDataByOrderId",
        {
          razorPayOrderId: response.razorpay_order_id,
          razorPayPaymentId: response.razorpay_payment_id,
          razorPaySignature: response.razorpay_signature,
          response: "SUCCESS",
        },
        { headers: header1 }
      )
      .subscribe(
        (data) => {
          this.g.loaderDisplay = "";
          if (data["code"] == 200) {
            this.alertService.success("Payment Success", data["message"]);
            this.router.navigate(["/admin/invoices"]);
          } else {
            this.alertService.error("Error", data["message"]);
          }
        },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        }
      );
  }

  updateFailurePayment(response) {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append("Content-Type", "application/json");
    header1 = header1.append("Accept", "application/json");
    header1 = header1.append(
      "Authorization",
      "Bearer " + localStorage.getItem("jwt")
    );
    this.http
      .post(
        environment.apiUrl + "api/updatePaymentDataByOrderId",
        {
          errorCode: response.error.code,
          errorDescription: response.error.description,
          errorSource: response.error.source,
          errorReason: response.error.reason,
          errorStep: response.error.step,
          razorPayOrderId: response.error.metadata.order_id,
          razorPayPaymentId: response.error.metadata.payment_id,
          response: "FAILURE",
        },
        { headers: header1 }
      )
      .subscribe(
        (data) => {
          this.g.loaderDisplay = "";
          if (data["code"] == 200) {
            this.alertService.success("Payment Failed", data["message"]);
          } else {
            this.alertService.error("Error", data["message"]);
          }
        },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        }
      );
  }

  /*   createRzpayOrder(data:any) {
    console.log(data);
    this.RazorPay();
    // call api to create order_id
    this.pay();
  } */

  pay() {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append("Content-Type", "application/json");
    header1 = header1.append("Accept", "application/json");
    header1 = header1.append(
      "Authorization",
      "Bearer " + localStorage.getItem("jwt")
    );
    this.http
      .post(
        environment.apiUrl +
        "api/createOrderInRazorPay?invoiceId=" +
        this.payMentId,
        null,

        { headers: header1 }
      )
      .subscribe(
        (data) => {
          this.g.loaderDisplay = "";
          this.storeId = data;
          if (data["code"] == 200) {
            this.alertService.success("orderId", data["message"]);
            this.storeId = data;
            let options: any = {
              key: environment.razorPayKey, // Enter the Key ID generated from the Dashboard
              amount: this.calculatedAmount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
              currency: "INR",
              image: "https://example.com/your_logo",
              order_id: this.storeId.orderId, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1,
              prefill: {
                name: this.payMent.ownerName,
                email: this.payMent.email,
                contact: this.payMent.mobile,
              },
              notes: {
                address: this.payMent.addressText,
              },
              theme: {
                color: "#3399cc",
              },
            };
            options.handler = (response: any, error: any) => {
              options.response = response;
              console.log("response::" + response);
              this.updateSuccessfulPayment(response);
            };

            const rzp1 = new this.payService.nativeWindow.Razorpay(options);
            rzp1.open();
            rzp1.on("payment.failed", (response: any) => {
              /*    alert(response.error.code);
               alert(response.error.description);
               alert(response.error.source);
               alert(response.error.step);
               alert(response.error.reason);
               alert(response.error.metadata.order_id);
               alert(response.error.metadata.payment_id); */
              //console.log("responce::" + response);
              //console.log(JSON.stringify(response));
              this.updateFailurePayment(response);
            });
          } else {
            this.alertService.error("Error", data["message"]);
          }
        },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        }
      );
  }
  blurPayment() {
    this.statusText1 = "";
    if (!this.selectedPaymentMode || !this.selectedPaymentMode.config) {
      this.statusText1 = "Please enter selected payment mode";
    }
  }
  processingPayment() {
    this.g.loaderDisplay = "display";
    this.statusText1 = "";
    this.statusText2 = "";
    this.statusText3 = "";
    this.statusText4 = "";
    this.statusText5 = "";
    if (!this.selectedPaymentMode || !this.selectedPaymentMode.config) {
      this.statusText1 = "Please enter selected payment mode";
    }

    if (
      this.imageUrl == "" ||
      this.imageUrl === null ||
      this.imageUrl === undefined ||
      this.imageUrl === "undefined"
    ) {
      this.statusText5 = "Please upload image";
    }

    this.g.loaderDisplay = "display";
    if (this.selectedPaymentMode.config == "CHEQUE") {
      this.externalRefNum = this.chequeNum;
      if (
        this.chequeNum == "" ||
        this.chequeNum === null ||
        this.chequeNum === undefined ||
        this.chequeNum === "undefined"
      ) {
        this.statusText2 = "Please enter cheque number";
      }
    } else if (this.selectedPaymentMode.config == "CASH") {
      this.externalRefNum = this.receiptNum;
      if (
        this.receiptNum == "" ||
        this.receiptNum === null ||
        this.receiptNum === undefined ||
        this.receiptNum === "undefined"
      ) {
        this.statusText4 = "Please enter receipt number";
      }
    } else if (this.selectedPaymentMode.config == "BANK_TRANSFER") {
      this.externalRefNum = this.refNum;
      if (
        this.refNum == "" ||
        this.refNum === null ||
        this.refNum === undefined ||
        this.refNum === "undefined"
      ) {
        this.statusText3 = "Please enter reference number";
      }
    }
    if (
      this.statusText1 != "" ||
      this.statusText2 != "" ||
      this.statusText3 != "" ||
      this.statusText4 != "" ||
      this.statusText5 != ""
    ) {
      this.g.loaderDisplay = "";
      return false;
    }

    var header1 = new HttpHeaders();
    header1 = header1.append("Content-Type", "application/json");
    header1 = header1.append("Accept", "application/json");
    header1 = header1.append(
      "Authorization",
      "Bearer " + localStorage.getItem("jwt")
    );
    this.http
      .post(
        environment.apiUrl + "api/updatePaymentStatus",
        {
          invoiceHeaderId: this.route.snapshot.params["id"],
          comments: this.comments,
          paymentStatus: "IN_PROCESS",
          paymentType: this.selectedPaymentMode.config,
          referenceImage: this.imageUrl,
          accountOwnerId: this.user.accountOwnerId,
          paymentRefNumber: this.externalRefNum,
        },
        { headers: header1 }
      )
      .subscribe(
        (data) => {
          this.g.loaderDisplay = "";
          if (data["code"] == 200) {
            this.alertService.success("Payment", "Status Updated Successfully");
            this.router.navigate([
              "/admin/paymentConfirmation",
              this.route.snapshot.params["id"],
            ]);
          } else {
            this.alertService.error("Error", data["message"]);
          }
        },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        }
      );
  }
  loadImage(event) {
    this.productImage = URL.createObjectURL(event.target.files[0]);
    this.uploadImage = event.target.files[0];
    this.errorMessage = "";
    this.submitImage();
  }
  ignoreImage() {
    this.productImage = "/assets/images/default-product.png";
    this.errorMessage = "";
  }
  submitImage() {
    this.g.loaderDisplay = "display";
    const file = this.uploadImage;
    const formData: FormData = new FormData();
    formData.append("file", file);
    var headerObj = new HttpHeaders();
    //headerObj = headerObj.append('content-Type', 'multipart/form-data');
    headerObj = headerObj.append(
      "Authorization",
      "Bearer " + localStorage.getItem("jwt")
    );
    this.http
      .post(environment.apiUrl + "api/uploadImageToS3", formData, {
        headers: headerObj,
      })
      .subscribe(
        (data) => {
          this.g.loaderDisplay = "";
          if (data["code"] == 200) {
            this.imageUrl = data["message"];
          } else {
            this.imageUrl = "";
          }
        },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          this.errorMessage = "Upload Image Failed Please Re-try";
        }
      );
  }
  reset() {
    this.statusText1 = "";
    this.statusText2 = "";
    this.statusText3 = "";
    this.statusText4 = "";
    this.statusText5 = "";
  }
}
